export default __webpack_public_path__ + "static/media/node.4a78d26e.svg";